import {enableProdMode}         from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import * as Sentry              from '@sentry/angular';
import packageInfo              from '../package.json';
import {AppModule}              from './app/app.module';
import {finalizeSentryErrorStatus, finalizeSentryTransactionStatus} from './app/shared/sentry-trace-status';
import {environment}            from './environments/environment';

if (environment.sentryEnabled) {
    Sentry.init({
        dsn: environment.sentryDSN,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.browserProfilingIntegration(),
            Sentry.replayIntegration(),
            Sentry.launchDarklyIntegration(),
        ],
        release: `${packageInfo.name}@${packageInfo.version}`,
        environment: environment.environmentName,
        tracesSampleRate: environment.sentryTracesSampleRate,
        beforeSend: finalizeSentryErrorStatus,
        beforeSendTransaction: finalizeSentryTransactionStatus,
        profileSessionSampleRate: environment.sentryProfileSessionSampleRate,
        profileLifecycle: 'trace',
        tracePropagationTargets: [
            'localhost',
            environment.apiUrl,
            environment.webPath,
        ],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    });
}

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => console.log(err));
